export const HasPermission = (value) => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const permissions = userData!= null ? userData.permissions : '';

    if(value === "") return false;

    return (value == undefined || permissions.includes(value));
}

export const IsAdmin = () => {
    const userData = localStorage.getItem('userData');
    const parsedData = JSON.parse(userData);
    return (parsedData != null && parsedData.isAdmin && parsedData.isAdmin.toLowerCase() === 'true');
}